import React from "react"

import { PageTitle } from "../components/StyledElements"
import { Box, Button, Grid, Typography } from "@mui/material"
import { PlaylistThumbnail } from "../components/PlaylistThumbnail"
import { useStaticContext } from "../services/static"
import { useNavigate } from "react-router-dom"
import { usePlaylistAPI } from "../services/api/hooks/usePlaylistAPI"
import { PlaylistQueryType } from "../services/api/playlist"

export const Playlists = (): React.ReactElement => {
  const { playlists, playlistsLoading: loading } = useStaticContext()
  const navigate = useNavigate()

  return loading ? (
    <></>
  ) : (
    <>
      <PageTitle>{"Mes playlists"}</PageTitle>
      <Box padding={2} px={"10%"}>
        <Button variant="contained" color="secondary" onClick={() => navigate("/addPlaylist")} sx={{ marginBottom: 2 }}>
          {"Créer une nouvelle playlist"}
        </Button>
        <Grid container spacing={2} py={8}>
          {playlists.length ? (
            playlists
              .sort((a, b) => a.title.localeCompare(b.title))
              .map((playlist) => (
                <Grid key={playlist.code} size={{ xs: 12, sm: 6, md: 3 }}>
                  <PlaylistThumbnail playlist={playlist} />
                </Grid>
              ))
          ) : (
            <Typography>{`Il n'y a rien ici... Pour l'instant ?`}</Typography>
          )}
        </Grid>
      </Box>
    </>
  )
}

export const FeaturedPlaylists = (): React.ReactElement => {
  const { playlistsData, loading } = usePlaylistAPI({ constraint: PlaylistQueryType.FEATURED })

  return loading ? (
    <></>
  ) : (
    <>
      <PageTitle>{"Playlists featurées"}</PageTitle>
      <Box padding={2} px={"10%"}>
        <Grid container spacing={2} py={8}>
          {playlistsData.length ? (
            playlistsData
              .sort((a, b) => a.title.localeCompare(b.title))
              .map((playlist) => (
                <Grid key={playlist.code} size={{ xs: 12, sm: 6, md: 3 }}>
                  <PlaylistThumbnail playlist={playlist} hideFeaturedIcon />
                </Grid>
              ))
          ) : (
            <Typography>{`Il n'y a rien ici... Pour l'instant ?`}</Typography>
          )}
        </Grid>
      </Box>
    </>
  )
}
